export const SET_IS_CASSETTE_EJECTING = "SET_IS_CASSETTE_EJECTING"; //for loader
export const SET_IS_SCAN_CANCELLED = "SET_IS_SCAN_CANCELLED";
export const SET_IS_SCANNING = "SET_IS_SCANNING"